import { render, staticRenderFns } from "./RinnovaTesseraModal.vue?vue&type=template&id=68a17d4e&"
import script from "./RinnovaTesseraModal.vue?vue&type=script&lang=ts&"
export * from "./RinnovaTesseraModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports